<svg
  [attr.viewBox]="viewBox"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  (mouseenter)="!isDisabled && hoverColor ? triggerHoverEffect() : null"
  (mouseleave)="!isDisabled && hoverColor ? setColor() : null"
  #icon
></svg>
